export const CONFIRM_CLIENT = 'CONFIRM_CLIENT';

export const RESET_CLIENT = 'RESET_CLIENT';

export const ON_LOAD = 'ON_LOAD';

export const FETCH_CLIENT_INFO = 'FETCH_CLIENT_INFO';
